// extracted by mini-css-extract-plugin
export default {"themeDark":"#00838f","theme":"#00acc1","themeMid":"#80deea","themeLight":"#b2ebf2"};